import { memo } from 'react';
import { RegionsEnum } from 'src/generated/operations';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { UserInput } from 'src/modules/user-input/types';
import { getUserInputFormFieldKey } from 'src/modules/common/hooks/getUserInputFormFieldKey.ts';
import { FormFieldNames } from 'src/modules/user-input/FormFieldNames.ts';
import { JoinReactNodes } from 'src/common/JoinReactNodes.tsx';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    is6WayRequired: boolean;
}

export const ValvesBreadcrumbValue = memo(({ region, state, is6WayRequired }: Props) => {
    const rows = FormFieldNames
        .filter((name) => {
            if (!is6WayRequired && name.includes('2')) {
                return false;
            }
            return state[name];
        })
        .map((name) => {
            const lines = [
                <I18n messageId={getUserInputFormFieldKey(region, name)}/>,
                state[name],
                <I18n messageId={state[`${name}_u`]}/>,
            ];
            return (<JoinReactNodes separator=" " content={lines}/>);
        });
    return (<JoinReactNodes separator=", " content={rows}/>);
});
